<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit process</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editProcess" @submit.prevent="saveChanges">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate :custom="{isUnique: isUnique}">
                  <v-text-field
                    v-model="data.process.name"
                    required
                    label="Name"
                    name="name"
                    maxlength="40"
                    hide-details
                    counter
                    clearable
                  >
                  </v-text-field>
                  <field-messages
                    name="name"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Name is a required field
                    </small>
                    <small class="error--text" slot="isUnique">
                      Name must be unique
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.process.stages"
                    :items="stages"
                    name="stages"
                    label="Select stages"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                  />
                  <field-messages
                    name="stages"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Stages is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>

              <v-flex xs3>
                <v-checkbox
                  v-model="isSaveAsSet"
                  label="Save as Set?"
                ></v-checkbox>

              </v-flex>

              <v-flex xs6 v-if="isSaveAsSet">
                <v-text-field
                  v-model="setName"
                  label="Set name"
                  maxlength="256"
                  hide-details
                ></v-text-field>
              </v-flex>

              <v-flex xs3 v-if="isSaveAsSet && !isSaved">
                <v-btn color="success" @click="saveSet" :loading="isSavingSet" :disabled="setName.length < 1 || isSavingSet || isSaved">
                  Save Set
                </v-btn>
              </v-flex>

              <v-flex xs3 v-if="isSaveAsSet && isSaved">
                <v-btn color="success" :disabled="true">
                  Saved
                </v-btn>
              </v-flex>

            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Process
  from '@/orm/models/Process';
import ProcessStages
  from '@/orm/models/ProcessStages';
import asyncAutocomplete
  from '@/components/form/asyncAutocomplete';
import ComponentSets from '@/orm/models/ComponentSets';

export default {
  name: 'editProcessPopup',
  props: {
    dialog: Boolean,
    process: Object,
    filteredProcess: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      data: {
        process: JSON.parse(JSON.stringify(this.process)),
      },
      stagesOrmModel: ProcessStages,
      editProcess: {},
      isSaveAsSet: false,
      isSavingSet: false,
      isSaved: false,
      setName: '',
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.data.process = JSON.parse(JSON.stringify(this.process));
      }
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    stages() {
      return ProcessStages.all().filter(p => this.filteredProcess.includes(p.id));
    },
  },
  methods: {
    isUnique(name) {
      return !Process.all()
        .filter(p => p.id !== this.process.id)
        .some(p => p.name === name);
    },
    close() {
      this.editProcess._reset();
      this.dialogLocal = false;

      this.isSaveAsSet = false;
      this.isSavingSet = false;
      this.isSaved = false;
      this.setName = '';
    },
    saveChanges() {
      if (!this.editProcess.$valid) {
        return;
      }
      this.$emit('update', this.data);
      this.close();
    },
    async saveSet() {
      this.isSavingSet = true;
      try {
        await ComponentSets.$create({
          data: {
            name: this.setName,
            object_type: 'PROCESS',
            content: {
              process: this.process,
            },
          },
        });
        this.isSaved = true;
        await ComponentSets.deleteAll();
        await ComponentSets.$fetch();
      } finally {
        this.isSavingSet = false;
      }
    }
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
